import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Popover from "@mui/material/Popover";
import PrimaryTextField from "../../../Inputs/PrimaryTextField/PrimaryTextField";
import FilterButton from "../../../Buttons/FilterButton/FilterButton";

export default function DefaultColumnFilter({
  column: { filterValue, setFilter, Header },
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if(filterValue) {
      setValue(filterValue);
    } else {
      setValue("");
    }
  }, [filterValue]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <>
      <FilterButton 
        filterValue={filterValue}
        onClick={handleClick}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: { boxShadow: "elevation3" },
          }
        }}
      >
        <div style={{ padding: "20px" }}>
          <PrimaryTextField
            id={`default-column-filter-${Header}`}
            value={value}
            label={`Filter ${Header}`}
            onChange={value => {
              setValue(value);
            }}
            onEnter={() => {
              setFilter(value || undefined);
              handleClose();
            }}
          />
        </div>
      </Popover>
    </>
  );
}

DefaultColumnFilter.propTypes = {
  column: PropTypes.object.isRequired
};